'use client';
import React from 'react';

const StarIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14" style={{ color: 'var(--accent)' }}>
    <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clipRule="evenodd" />
  </svg>;

const MapPinIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="11" height="11" style={{ color: 'var(--muted-foreground)' }}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
  </svg>;

const testimonials = [
{
  quote: 'My father suffered a stroke, and choosing Dr. Physio Home Physiotherapy Services was one of the best decisions we made. The physiotherapist provided professional, compassionate care at home, helping him regain strength, balance, and confidence with every session. We are truly grateful for the excellent support and highly recommend Dr. Physio Home Physiotherapy Services to anyone seeking quality stroke rehabilitation at home.',
  tags: ['Stroke Rehabilitation'],
  name: 'Shebin Mathew',
  role: 'Family of stroke patient',
  location: 'Kochi, Kerala',
},
{
  quote: 'As an IT professional, I developed a disc bulge that caused persistent back pain and made it difficult to sit and work for long hours. Dr. Physio Home Physiotherapy Services provided expert home physiotherapy with a personalized treatment plan that significantly reduced my pain, improved my posture, and helped me return to work comfortably. I sincerely appreciate the professional care and highly recommend Dr. Physio Home Physiotherapy Services to anyone seeking effective treatment for back pain and disc-related problems.',
  tags: ['Back Pain', 'Disc Bulge'],
  name: 'Shreya Gopan',
  role: 'IT Professional',
  location: 'Kochi, Kerala',
},
{
  quote: 'After my knee surgery, I was worried about regaining my mobility and returning to my normal routine. Dr. Physio Home Physiotherapy Services provided exceptional home physiotherapy with personalized rehabilitation exercises, helping me reduce pain, improve my knee movement, and walk confidently again. I am truly grateful for the dedicated care and highly recommend Dr. Physio Home Physiotherapy Services to anyone recovering from knee surgery.',
  tags: ['Knee Surgery Recovery'],
  name: 'Krishna Kumar',
  role: 'Post Knee Surgery',
  location: 'Kochi, Kerala',
}];

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="section-pad-lg overflow-hidden relative" style={{ backgroundColor: 'var(--background)' }}>
      <div className="absolute inset-0 mask-radial blob-accent opacity-30 -z-10"></div>
      <div className="mx-auto max-w-6xl px-6">
        {/* Header */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-4">
            <span className="service-tag">Patient Results</span>
            <h2 className="text-section-xl font-display font-bold italic text-gradient-gold">
              Real patients.<br />Real recoveries.
            </h2>
          </div>
          <div>
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center">
                <p className="text-3xl font-display font-bold" style={{ color: 'var(--primary)' }}>97%</p>
                <p className="text-xs mt-1 font-medium" style={{ color: 'var(--muted-foreground)' }}>Patient satisfaction</p>
              </div>
              <div className="text-center">
                <p className="text-3xl font-display font-bold" style={{ color: 'var(--primary)' }}>Kochi</p>
                <p className="text-xs mt-1 font-medium" style={{ color: 'var(--muted-foreground)' }}>Service area — Kerala, India</p>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {testimonials?.map((t) =>
          <div key={t?.name} className="bento-card flex flex-col">
              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {[0, 1, 2, 3, 4]?.map((i) => <StarIcon key={i} />)}
              </div>

              {/* Quote */}
              <p className="text-base font-display italic leading-relaxed flex-1" style={{ color: 'var(--foreground)' }}>
                &ldquo;{t?.quote}&rdquo;
              </p>

              {/* Tags */}
              <div className="flex gap-2 mt-4 flex-wrap">
                {t?.tags?.map((tag) =>
              <span key={tag} className="service-tag">{tag}</span>
              )}
              </div>

              {/* Author - no avatar */}
              <div className="flex items-center gap-3 mt-5 pt-5" style={{ borderTop: '1px solid var(--border)' }}>
                <div>
                  <p className="text-sm font-bold" style={{ color: 'var(--foreground)' }}>{t?.name}</p>
                  <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{t?.role}</p>
                  <div className="flex items-center gap-1 mt-0.5">
                    <MapPinIcon />
                    <span className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{t?.location}</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);
}
